module.exports = __webpack_public_path__ + "static/media/IMG_0783_Reduced.ce659e56.jpg";